import createReactContext from "create-react-context";

var RouterContext = createReactContext({});

export default RouterContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/es/RouterContext.js
// module id = 1085
// module chunks = 0